const waitForElement = (element, callback) => {
    const waitingInterval = setInterval(() => {
        var selector = document.querySelector(element);
        if (selector) {
            callback();
            clearInterval(waitingInterval);
        }
    }, 180);
};

waitForElement(".kl_reviews__carousel__header", () => {
    const heading = document.querySelector(".kl_reviews__carousel__header");
    const template = `
<style>
  .reviews-swiper__rating {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: "Gotham-Book";
    font-size: 12px;
    color: #6b6b6b;
    margin-bottom: 30px;
  }

  .reviews-swiper__stars {
    display: inline-flex;
    gap: 2px;
    line-height: 1;
  }

  .reviews-swiper__star {
    font-size: 12px;
    color: #9a9a78;
  }

  .reviews-swiper__rating-text {
    white-space: nowrap;
    font-family: "Gotham-Medium";
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #83876B;
  }
</style>

<div class="reviews-swiper__rating">
  <div class="reviews-swiper__stars">
    ${Array(5).fill(`
      <svg class="reviews-swiper__star" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.90303 0.5625C9.73741 0.21875 9.38741 0 9.00303 0C8.61866 0 8.27178 0.21875 8.10303 0.5625L6.09366 4.69688L1.60616 5.35938C1.23116 5.41563 0.918658 5.67812 0.803033 6.0375C0.687408 6.39687 0.781158 6.79375 1.04991 7.05937L4.30616 10.2812L3.53741 14.8344C3.47491 15.2094 3.63116 15.5906 3.94053 15.8125C4.24991 16.0344 4.65928 16.0625 4.99678 15.8844L9.00616 13.7437L13.0155 15.8844C13.353 16.0625 13.7624 16.0375 14.0718 15.8125C14.3812 15.5875 14.5374 15.2094 14.4749 14.8344L13.703 10.2812L16.9593 7.05937C17.228 6.79375 17.3249 6.39687 17.2062 6.0375C17.0874 5.67812 16.778 5.41563 16.403 5.35938L11.9124 4.69688L9.90303 0.5625Z"
          fill="#83876B"/>
      </svg>
    `).join("")}
  </div>
  <span class="reviews-swiper__rating-text">4.9 out of 5 stars</span>
</div>
`;


    heading.insertAdjacentHTML('afterend', template)
});